'use strict';

import React from 'react';
import TextInput from 'components/base/form-components/TextInput';
import CalendarWrapper from 'components/base/Calendar/CalendarWrapper';

import utils from 'services/utils';
import constants from 'constants/appConstants';
import moment from 'moment';
import modalActions from 'actions/ModalActionCreators';

import 'styles/DateInput.scss';


const defaultProps = {
    validations: {},
    validationErrors: {},
};

let timeout;

class DateInput extends React.Component {

    constructor(props) {
        super(props);
        this.hideCalendar = this.hideCalendar.bind(this);
        this.showCalendar = this.showCalendar.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleOnChangeCallback = this.handleOnChangeCallback.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.state = {
            calendarVisible: false,
            currentDate: this.props.value || moment(),
        };
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClick);
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    componentWillReceiveProps(props) {
        if (props.value) {
            this.setState({
                currentDate: props.value,
            });
        }
    }

    getNodeCallback = (node) => {
        this.setState({
            childNode: node,
        });
    }

    hideCalendar() {

        modalActions.enableEscapeButton();
        this.setState({
            calendarVisible: false,
        });

        document.removeEventListener("click", this.handleClick);
        document.removeEventListener("keydown", this.handleKeyDown);

        setTimeout(function () {
            this.state.childNode.focus();
        }.bind(this), 0);

    }

    handleClick(event) {
        utils.preventDefault(event);
        this.hideCalendar();
    }

    showCalendar(event) {
        modalActions.disableEscapeButton();
        utils.preventDefault(event);

        var inputHtml = this.node;
        var value = inputHtml.getValue();
        this.state.childNode.setSelectionRange(0, value.length);

        this.setState({
            calendarVisible: true,
        }, function () {
            document.addEventListener("click", this.handleClick);
            document.addEventListener("keydown", this.handleKeyDown);
        });
    }

    handleKeyDown(event) {
        event.stopPropagation();
        this.hideCalendar();
    }

    handleOnChangeCallback(event, currentDate) {
        const _this = this;
        const date = moment(event.currentTarget.value, constants.dates.formats.MINIMAL);

        clearTimeout(timeout);

        if (date.isValid()) {
            timeout = setTimeout(function () {
                this.setState({
                    currentDate: date,
                }, function () {
                    if (_this.props.onChangeCallback) {
                        _this.props.onChangeCallback(_this, date);
                    }
                });
            }.bind(this), 1000);
        }
    }

    handleDayClick(day, currentDate) {
        const _this = this;
        clearTimeout(timeout);
        this.setState({
            currentDate: day,
        }, function () {
            if (_this.props.onChangeCallback) {
                _this.props.onChangeCallback(_this, day);
            }
        });
        this.hideCalendar();
    }

    render() {

        var _props = this.props;
        _props.validations.matchRegexp = constants.regex.DATE;
        _props.validationErrors.matchRegexp = constants.error.FORMS.DATE_FORMAT;

        return (
            <div className="date-input">
                <TextInput
                    {..._props}
                    ref={(n) => this.node = n}
                    value={this.state.currentDate.format(constants.dates.formats.MINIMAL)}
                    getNodeCallback={this.getNodeCallback}
                    onClickCallback={this.showCalendar}
                    placeholder={constants.dates.formats.MINIMAL.toLowerCase()}
                    onChangeCallback={this.handleOnChangeCallback}
                    autocomplete="off"

                />
                {this.state.calendarVisible ? (
                    <CalendarWrapper
                        year={this.state.currentDate.year()}
                        month={this.state.currentDate.month() + 1}
                        handleDayClickCallback={this.handleDayClick}
                        currentDate={this.state.currentDate}
                    />
                ) : null}
            </div>
        );
    }
}

DateInput.defaultProps = defaultProps;
export default DateInput; 
